<script setup lang="ts">
/**
 * Root component.
 *
 * Deliberately thin: it owns the route transition and the global loading
 * overlay (which must cover the login page too, hence here and not in
 * AppShell). The authenticated chrome (sidebar, header, inactivity timer)
 * lives in AppShell.vue, which is a layout route — that way the login page
 * renders on a bare canvas with no navigation around it.
 */
import GlobalLoadingOverlay from '@/components/GlobalLoadingOverlay.vue';
</script>

<template>
  <RouterView v-slot="{ Component }">
    <Transition name="route" mode="out-in">
      <component :is="Component" />
    </Transition>
  </RouterView>
  <GlobalLoadingOverlay />
</template>
